import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/solicitudes-percepciones-empleados-periodos';

/**
 * GET Solicitudes Percepciones Empleados Periodos
 * @param {object} params - Filtros (ej. { solicitud_percepcion_empleado: 123 })
 * @returns {Promise<object[]>}
 */
export const getSolicitudesPercepcionesEmpleadosPeriodos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data; // Devuelve la lista de periodos guardados
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Solicitud Percepcion Empleado Periodo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSolicitudPercepcionEmpleadoPeriodo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Periodo agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Solicitud Percepcion Empleado Periodo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSolicitudPercepcionEmpleadoPeriodo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Periodo eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
